import {IProductListFilterItem, ProductListFilterItem} from "./ProductListFilterItem";
import {IAvailableFilter} from "../items/interface/Item.interface";

export class ProductListFilterItemRange extends ProductListFilterItem implements IProductListFilterItem {
  public readonly range: number[];

  protected _value: ProductListFilterItemRangeValue;

  public constructor(filterItemData: IAvailableFilter) {
    super(filterItemData);

    this.range = filterItemData.values
      .map((value) => {
        return parseFloat(value.id);
      })
      .sort();

    this._value = this.getValueFromResult(filterItemData);
  }

  public get min(): number {
    return Math.min(...this.range);
  }

  public get max(): number {
    return Math.max(...this.range);
  }

  public get value(): ProductListFilterItemRangeValue {
    return this._value;
  }

  public set value(value: ProductListFilterItemRangeValue) {
    this._value = {
      min: Math.max(value.min, this.min),
      max: Math.min(value.max, this.max),
    };
  }

  public get paramValue(): string {
    const value = this.value;

    if (value.min !== this.min || value.max !== this.max) {
      return `${value.min !== this.min ? value.min : ""}-${value.max !== this.max ? value.max : ""}`;
    }

    return "";
  }

  public clear() {
    this._value = {
      min: this.min,
      max: this.max,
    };
  }

  public getValueFromResult(filterItem: IAvailableFilter): ProductListFilterItemRangeValue {
    return {
      min: Number(filterItem.minValue) || this.min,
      max: Number(filterItem.maxValue) || this.max,
    };
  }

  public applyFilterItemResult(filterItem: IAvailableFilter): void {
    this._value = this.getValueFromResult(filterItem);
  }
}

export interface ProductListFilterItemRangeValue {
  min: number;
  max: number;
}
